import { completeQuoteHeaderUploads } from 'src/app/views/dashboard/quote/quote-form-header/quote-header-upload';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { ChangeDetectorRef, Component, OnInit, ViewChild, ViewChildren, ElementRef, QueryList } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import {
  FormArray,
  FormControl,
  FormGroup,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { SettingsService } from 'src/app/views/settings/settings.service';
import { Observable, from } from 'rxjs';
import { Page } from 'src/app/shared/models/page';
import {
  Currency,
  quoteAttachmentType,
  quoteDeclineReasonType,
} from 'src/app/shared/models/settings.model';
import { FullLoaderService } from 'src/app/shared/services/full-loader.service';
import { ServiceRfqTokenAuthService } from 'src/app/shared/services/service-rfq-token-auth.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { QuoteService } from '../../dashboard/quote/quote.service';
import { NgxFileDropEntry } from 'ngx-file-drop';
import { MatSelectChange } from '@angular/material/select';
import { v4 as uuidv4 } from 'uuid';
import { WebApiService } from 'src/app/shared/services/web-api.service';
import { AwsSdkService } from 'src/app/shared/services/aws-sdk.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  // Issue 7 — force Material form-field labels on this screen to float to
  // the top so they never rest over / overlap the input value.
  providers: [
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { floatLabel: 'always' } },
  ],
  selector: 'app-service-rfq-token-quote-line-items',
  templateUrl: './serviceQuoteLineItems.component.html',
  styleUrls: ['./serviceQuoteLineItems.component.css'],
})
export class ServiceRfqTokenQuoteLineItemsComponent implements OnInit {
  @ViewChild('table') table!: DatatableComponent;
  isTotalsCardOpen: boolean = false;
  serviceRfqId!: number;
  quoteId!: number;
  isSaved: boolean = false;
  currentTab: string = 'line-items';
  tabEnabled: boolean = false;

  showConfirmationDialogue: boolean = false;
  showSuccessDialogue: boolean = false;
  showCloseDialogue: boolean = false;
  previewSection: boolean = false;
  previewDocs: any[] = [];
  currentIndex = 0;
  isFreight: boolean = false;

  tabs: any[] = [
    { index: 0, label: 'LINE ITEMS', icon: 'directions_boat', route: 'line-items' },
    { index: 1, label: 'HEADER DETAILS', icon: 'looks', route: 'header' },
    { index: 2, label: 'PAYMENT TERMS', icon: 'location_searching', route: 'payment-terms' },
    { index: 3, label: 'PREVIEW', icon: 'location_searching', route: 'preview' },
  ];

  showNotification: boolean = false;
  notificationMessage: string = '';
  notificationTitle: string = '';
  notificationType: 'error' | 'info' = 'error';

  secondFormGroup!: UntypedFormGroup;
  lineItemtableForm!: any;
  row: any = [];
  dataSource: any[] = [];
  headerData: any;
  showDetailSection: boolean = false;
  isWrapDescription: boolean = false;

  isEditingGeneralDiscount: boolean = false;
  generalDiscountAmount: number = 0;
  @ViewChildren('generalDiscountInput')
  generalDiscountInputs!: QueryList<ElementRef<HTMLInputElement>>;

  showAddDocumentSection: boolean = false;
  showAddCostSection: boolean = false;
  showDeclineSection: boolean = false;

  showOtherReason: boolean = false;
  showHazardousDeclaration: boolean = false;

  lineItemAttachmentTypeData: quoteAttachmentType[] = [];
  delineReasonData: quoteDeclineReasonType[] = [];

  selectedLineItemIndex!: number | null;

  declineReason!: number | null;
  otherReason: string = '';

  freightDescription: string = '';
  freightType: string = 'amount';
  freightValue!: number | null;
  addedAdditionalCost: any[] = [];

  selectedAttachmentType!: number | null;
  hazardousDeclaration!: number | null;
  newfileuploaded: boolean = false;
  uploadedAttachmentsArray: any[] = [];
  acceptedAttachmentExtenstion: any = ['.pdf', '.jpg', '.jpeg', '.png'];
  maxFileSize: number = 10 * 1024 * 1024;

  currentdate = new Date();
  taxStatusData: any[] = [];

  quoteLineItemTaxType: string | null = null;
  isFreightCost: boolean = true;

  // Tax Profile Sidebar
  showTaxSideBar: boolean = false;
  taxForm!: FormGroup;
  countryList: any[] = [];
  filteredCountryList: any[] = [];
  countryRegions: any[] = [];
  _selectedCountryCode: string = '';
  gstCertificateFile!: File;

  exchangeRatesCache: any = {};

  dynamicColumns = [
    { key: 'attachments', name: 'Attachments', visible: false },
    { key: 'requestedUnitCost', name: 'Requested Unit Cost', visible: false },
    { key: 'requestedTotalCost', name: 'Requested Total Cost', visible: false },
  ];

  boundGetCurrencyAutoComplete!: (pageMeta: Page) => Observable<any>;
  searchKeyParams: string = '';

  constructor(
    private snack: MatSnackBar,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private _formBuilder: UntypedFormBuilder,
    private cdr: ChangeDetectorRef,
    private SettingsService: SettingsService,
    private fullLoaderService: FullLoaderService,
    private quoteService: QuoteService,
    private serviceRfqTokenAuth: ServiceRfqTokenAuthService,
    private webApiService: WebApiService,
    private awsSdkService: AwsSdkService,
    private http: HttpClient,
  ) {
    this.lineItemtableForm = this._formBuilder.group({
      rows: this._formBuilder.array([]),
    });
  }

  private round3(value: any): number {
    const n = Number(value) || 0;
    return Math.round((n + Number.EPSILON) * 1000) / 1000;
  }

  async ngOnInit() {
    this.fullLoaderService.showLoader();

    this.boundGetCurrencyAutoComplete =
      this.getCurrencyFilterKeyDataObservable.bind(this);

    this.getTaxDetails();

    // Initialize tax profile form
    this.taxForm = this._formBuilder.group({
      taxId: [null],
      nameOfTaxProfile: [null, Validators.required],
      country: [null, Validators.required],
      region: [null, Validators.required],
      regionName: [null, Validators.required],
      taxType: [],
      taxNumber: [],
      taxPercentage: [],
      gstCertificateAttachment: [],
      s3FilePath: [''],
    });

    // Load countries for tax profile sidebar
    this.loadCountryList();

    this.secondFormGroup = this._formBuilder.group({
      quoteLineItemHeaderId: [null],
      quoteLineItemListPriceSubtotal: [null],
      quoteLineItemDiscount: [null],
      quoteLineItemSubtotal: [null],
      quoteLineItemGeneralDiscountType: ['percentage'],
      quoteLineItemGeneralDiscountValue: [null],
      quoteLineItemFreightTotal: [null],
      quoteLineItemFreight: [null],
      quoteLineItemTotal: [null],
      supplierCurrency: [null],
      quoteLineItemApplicableTaxProfile: [null],
      quoteLineItemTaxAmount: [null],
      quoteLineItemTaxType: [null],
    });

    this.lineItemtableForm = this._formBuilder.group({
      rows: this._formBuilder.array([]),
    });

    this.lineItemAttachmentTypeData =
      await this.quoteService.fetchAllQuteAttachmentTypeByServiceRfqToken('QuoteLineItemAttachmentType');

    this.delineReasonData = await this.quoteService.fetchAllServiceDeclineReasonByServiceRfqToken();

    this.activatedRoute.queryParams.subscribe(async (params) => {
      if (params['serviceRfqId'] != '' && params['quoteId'] != '') {
        this.serviceRfqId = params['serviceRfqId'];
        this.quoteId = params['quoteId'];
        this.getQuoteDraftData();
      }
    });

    this.fetchServiceRfqDetails();
  }

  showColumn(col: { key: string; name: string; visible: boolean }) {
    col.visible = !col.visible;
    this.table.recalculate();
  }

  showToggleColumns(col: any) {
    col.visible = !col.visible;
    this.table.recalculate();
  }

  getColumn(key: string) {
    return this.dynamicColumns.find((c) => c.key === key);
  }

  async save(isDraft?: boolean) {
    console.log('INSIDE SAVE - Service Quote Line Items');

    if (isDraft) {
      this.showConfirmationDialogue = false;
      this.showCloseDialogue = false;
    } else {
      const missingFields = this.isValidRequiredFields();
      if (missingFields.length > 0) {
        return;
      }
    }

    const lineitems = this.lineItemtableForm.value.rows;
    const activeLineItems = lineitems.filter(
      (item: { isActive: number }) => item.isActive === 1
    );

    if (activeLineItems.length == 0) {
      this.snack.open('At least one active line item should be present.', 'OK', {
        duration: 3000,
      });
      return;
    }

    this.fullLoaderService.showLoader();

    // Upload attachments to S3
    for (let rowIndex = 0; rowIndex < lineitems.length; rowIndex++) {
      const row = lineitems[rowIndex];
      let attachmentFiles: any = {};
      let attachmentArray = row.attachments || [];
      const serviceCode = row.serviceCode || 'service';

      attachmentArray = attachmentArray.filter(
        (item: { file: any }) => item.file
      );

      let uploadPath = `quotation/${this.quoteId}/${serviceCode}`;

      await Promise.all(
        attachmentArray.map(async (attachment: any) => {
          if (!attachment.file) return;

          let fileExt = attachment.name.slice(
            ((attachment.name.lastIndexOf('.') - 1) >>> 0) + 2
          );
          let fileNameSystem = `${uuidv4()}.${fileExt}`;
          attachment.systemName = fileNameSystem;
          // 2026-10-26: a fresh key per upload - a supplier on a link cannot replace an existing file (Supplier-API upload rules).
          let s3Location = `${uploadPath}/${Date.now()}-${attachment.file.name}`;

          let _s3Params = {
            fileKey: s3Location,
            fileContentType: (<File>attachment.file).type,
          };
          attachment.s3Params = _s3Params;
          attachmentFiles[attachment.file.name] = attachment.file;
        })
      );

      try {
        const signed = await this.quoteService.getBulkAttachmentUrlsByServiceRfqToken(attachmentArray);
        const uploaded = await completeQuoteHeaderUploads(attachmentArray, signed,
          (url, file) => this.webApiService.putRequestExternalApi(url, file),
          url => this.awsSdkService.extractS3LocationFromUrl(url));
        const saved = (row.attachments || []).filter((item: any) => item && !item.file);
        row.attachments = [...saved, ...uploaded];
      } catch (error) {
        this.fullLoaderService.hideLoader();
        this.snack.open('Attachment upload failed. Please retry.', 'OK', { duration: 5000 });
        return;
      }
    }

    const lineItemHeaderDataRaw = this.secondFormGroup.value;

    const lineItemHeaderData = {
      ...lineItemHeaderDataRaw,
      quoteLineItemListPriceSubtotal: this.round3(lineItemHeaderDataRaw?.quoteLineItemListPriceSubtotal),
      quoteLineItemDiscount: this.round3(lineItemHeaderDataRaw?.quoteLineItemDiscount),
      quoteLineItemSubtotal: this.round3(lineItemHeaderDataRaw?.quoteLineItemSubtotal),
      quoteLineItemTaxAmount: this.round3(lineItemHeaderDataRaw?.quoteLineItemTaxAmount),
      quoteLineItemFreightTotal: this.round3(lineItemHeaderDataRaw?.quoteLineItemFreightTotal),
      quoteLineItemGeneralDiscountValue: this.round3(lineItemHeaderDataRaw?.quoteLineItemGeneralDiscountValue),
      quoteLineItemTotal: this.round3(lineItemHeaderDataRaw?.quoteLineItemTotal),
      quoteLineItemFreight: Array.isArray(lineItemHeaderDataRaw?.quoteLineItemFreight)
        ? lineItemHeaderDataRaw.quoteLineItemFreight.map((f: any) => ({
            ...f,
            freightValue: this.round3(f?.freightValue),
          }))
        : lineItemHeaderDataRaw?.quoteLineItemFreight,
    };

    const lineItemTableRaw = { ...this.lineItemtableForm.value, rows: lineitems };

    const lineItemTable = {
      ...lineItemTableRaw,
      rows: Array.isArray(lineItemTableRaw?.rows)
        ? lineItemTableRaw.rows.map((r: any) => ({
            ...r,
            unitCost: this.round3(r?.unitCost),
            discountedUnitPrice: this.round3(r?.discountedUnitPrice),
            totalCost: this.round3(r?.totalCost),
            requestedUnitCost: this.round3(r?.requestedUnitCost),
            requestedTotalCost: this.round3(r?.requestedTotalCost),
          }))
        : [],
    };

    const params1 = {
      section: 'tab2',
      isDraft: isDraft,
      quoteStatus: isDraft ? 14 : 2,
      tabId: 1,
      quoteId: this.quoteId,
      lineItemData: lineItemHeaderData,
      lineItemTableData: lineItemTable,
      serviceRfqId: this.serviceRfqId,
    };

    if (
      this.quoteId &&
      this.isSaved &&
      this.secondFormGroup.get('quoteLineItemHeaderId')?.value != null
    ) {
      console.log('updateServiceQuoteDraft called in serviceQuoteLineItems');
      const result1 = await this.quoteService.updateServiceQuoteDraftByServiceRfqToken(params1);

      if (result1?.data) {
        console.log('result1 of updated service quote draft from line items', result1.data);
        this.fullLoaderService.hideLoader();

        if (isDraft) {
          this.router.navigate(['/serviceRfqToken/rfqDetails', this.serviceRfqId]);
        }
      } else {
        this.fullLoaderService.hideLoader();
        throw new Error('Invalid response format: Expected { data: number }');
      }
    } else {
      console.log('saveServiceQuoteAsDraft is called in serviceQuoteLineItems');
      const result1 = await this.quoteService.saveServiceQuoteAsDraftByServiceRfqToken(params1);

      if (result1?.data) {
        this.isSaved = true;
      } else {
        this.fullLoaderService.hideLoader();
        throw new Error('Invalid response format: Expected { data: number }');
      }
    }
  }

  async back() {
    this.activatedRoute.queryParams.subscribe(async (params) => {
      if (params['serviceRfqId'] != '' && params['quoteId'] != '') {
        this.serviceRfqId = params['serviceRfqId'];
        this.quoteId = params['quoteId'];

        this.router.navigate(['/serviceRfqToken/rfqDetails', this.serviceRfqId]);
      }
    });
  }

  closeLineItems() {
    this.router.navigate(['/serviceRfqToken/rfqDetails', this.serviceRfqId]);
  }

  async next() {
    if (this.isSaved) {
      this.activatedRoute.queryParams.subscribe(async (params) => {
        if (params['serviceRfqId'] != '' && params['quoteId'] != '') {
          this.serviceRfqId = params['serviceRfqId'];
          this.quoteId = params['quoteId'];

          this.router.navigate(['/serviceRfqToken/rfqDetails', this.serviceRfqId]);
        }
      });
    }
  }

  calculateRowValues(index: number): void {
    const form = this.lineItemtableForm.get('rows') as FormArray;
    const row = form.at(index);

    if (!row) {
      console.error(`No row found at index ${index}`);
      return;
    }

    const quantity = parseFloat(row.get('supplierQuantity')?.value || '0');
    const unitCost = parseFloat(row.get('unitCost')?.value || '0');
    const discount = parseFloat(row.get('discount')?.value || '0');

    const discountedUnitPrice = this.round3(unitCost * (1 - discount / 100));
    const totalCost = this.round3(quantity * discountedUnitPrice);

    row.get('discountedUnitPrice')?.setValue(discountedUnitPrice, { emitEvent: false });
    row.get('totalCost')?.setValue(totalCost, { emitEvent: false });

    this.calculateCostSummary();
  }

  calculateCostSummary() {
    let subTotalCost = 0;
    let totalDiscount = 0;
    let totalUnitCost = 0;
    let totalCost = 0;
    let totalFreightAmount = 0;
    let taxPercentage = 0;
    let taxAmount = 0;

    const lineItemTable = this.lineItemtableForm.value;
    const row = lineItemTable.rows;

    row.forEach((item: any) => {
      if (item.isActive === 1) {
        const quantity = item.supplierQuantity || 0;
        const unitCost = item.unitCost || 0;
        const discount = item.discount || 0;
        const discountedUnitPrice = item.discountedUnitPrice || 0;

        const rowTotalCost = this.round3(discountedUnitPrice * quantity);
        const rowDiscount = this.round3(unitCost * (discount / 100) * quantity);
        const rowUnitCost = this.round3(unitCost * quantity);

        subTotalCost = this.round3(subTotalCost + rowTotalCost);
        totalDiscount = this.round3(totalDiscount + rowDiscount);
        totalUnitCost = this.round3(totalUnitCost + rowUnitCost);
        totalCost = this.round3(totalCost + rowTotalCost);
      }
    });

    this.generalDiscountAmount = 0;

    if (this.secondFormGroup.get('quoteLineItemGeneralDiscountType')?.value != null) {
      const type = this.secondFormGroup.get('quoteLineItemGeneralDiscountType')?.value;
      const genDiscount = parseFloat(
        this.secondFormGroup.get('quoteLineItemGeneralDiscountValue')?.value || '0'
      );

      if (!isNaN(genDiscount) && genDiscount > 0) {
        if (type == 'percentage') {
          this.generalDiscountAmount = this.round3((genDiscount / 100) * totalCost);
          totalCost = this.round3(totalCost - this.generalDiscountAmount);
        } else {
          this.generalDiscountAmount = this.round3(genDiscount);
          totalCost = this.round3(totalCost - this.generalDiscountAmount);
        }
      }
    }

    if (this.secondFormGroup.get('quoteLineItemFreight')?.value != null) {
      const freight = this.secondFormGroup.get('quoteLineItemFreight')?.value;

      if (freight.length > 0) {
        freight.forEach((item: { freightValue: string; freightType: string }) => {
          const freightValue = this.round3(parseFloat(item.freightValue));

          if (item.freightType === 'percentage') {
            const increment = this.round3((freightValue / 100) * totalCost);
            totalCost = this.round3(totalCost + increment);
            totalFreightAmount = this.round3(totalFreightAmount + increment);
          } else if (item.freightType === 'amount') {
            totalCost = this.round3(totalCost + freightValue);
            totalFreightAmount = this.round3(totalFreightAmount + freightValue);
          }
        });
      }
    }

    if (this.secondFormGroup.get('quoteLineItemApplicableTaxProfile')?.value != null) {
      const selectedTaxId = this.secondFormGroup.get('quoteLineItemApplicableTaxProfile')?.value;
      const selectedTaxProfile = this.taxStatusData.find(
        (tax) => tax.taxId === Number(selectedTaxId)
      );

      if (selectedTaxProfile && selectedTaxProfile.taxPercentage) {
        taxPercentage = parseFloat(selectedTaxProfile.taxPercentage);
      }

      if (!isNaN(taxPercentage) && taxPercentage > 0) {
        taxAmount = this.round3((subTotalCost * taxPercentage) / 100);
        totalCost = this.round3(totalCost + taxAmount);
      }
    }

    this.secondFormGroup.get('quoteLineItemTaxAmount')?.setValue(this.round3(taxAmount), { emitEvent: false });
    this.secondFormGroup.get('quoteLineItemFreightTotal')?.setValue(this.round3(totalFreightAmount), { emitEvent: false });
    this.secondFormGroup.get('quoteLineItemListPriceSubtotal')?.setValue(this.round3(totalUnitCost), { emitEvent: false });
    this.secondFormGroup.get('quoteLineItemDiscount')?.setValue(this.round3(totalDiscount), { emitEvent: false });
    this.secondFormGroup.get('quoteLineItemSubtotal')?.setValue(this.round3(subTotalCost), { emitEvent: false });
    this.secondFormGroup.get('quoteLineItemTotal')?.setValue(this.round3(totalCost), { emitEvent: false });

    const convert_rows = this.lineItemtableForm.get('rows') as FormArray;

    // Loop through all rows in the FormArray for currency conversion
    for (let i = 0; i < convert_rows.length; i++) {
      const row = convert_rows.at(i);

      const baseCurrency = this.headerData?.currencyId?.currencyCode || 'EUR';
      const supplierCurrency =
        this.secondFormGroup.get('supplierCurrency')?.value?.currencyCode ||
        'EUR';
      const supplierUnitCost = row.get('unitCost')?.value || 0;
      const supplierTotalCost = row.get('totalCost')?.value || 0;

      if (!baseCurrency) {
        this.snack.open('Buyer does not have a currency code', 'Close', {
          duration: 4000,
        });
        return;
      }

      if (!this.exchangeRatesCache[baseCurrency]) {
        const url = `https://v6.exchangerate-api.com/v6/${environment.exchangeRate_apiKey}/latest/${baseCurrency}`;
        this.http.get(url).subscribe(
          (res: any) => {
            if (res.result === 'success') {
              this.exchangeRatesCache[baseCurrency] = res.conversion_rates;

              this.applyConversionToUnitCost(
                row,
                supplierCurrency,
                baseCurrency,
                supplierUnitCost
              );
              this.applyConversionToTotalCost(
                row,
                supplierCurrency,
                baseCurrency,
                supplierTotalCost
              );
            }
          },
          (error: any) => {
            if (error && error.status === 429) {
              this.snack.open(
                'Currency exchange API limit exceeded.',
                'OK',
                { duration: 7000 }
              );
            }
          }
        );
      } else {
        this.applyConversionToUnitCost(
          row,
          supplierCurrency,
          baseCurrency,
          supplierUnitCost
        );
        this.applyConversionToTotalCost(
          row,
          supplierCurrency,
          baseCurrency,
          supplierTotalCost
        );
      }
    }
  }

  onEditGeneralDiscountClick() {
    this.isEditingGeneralDiscount = true;
    setTimeout(() => {
      const inputEl = this.generalDiscountInputs?.first?.nativeElement;
      if (inputEl) {
        inputEl.focus();
        try { inputEl.select?.(); } catch {}
      }
    }, 0);
  }

  onGeneralDiscountBlur() {
    this.isEditingGeneralDiscount = false;
    this.calculateCostSummary();
  }

  populateForm(data: any[]) {
    data.forEach((item) => {
      this.addRow(item);
    });
  }

  allowOnlyLetters(event: KeyboardEvent) {
    const charCode = event.key.charCodeAt(0);
    if (
      !(charCode >= 65 && charCode <= 90) &&
      !(charCode >= 97 && charCode <= 122) &&
      !(charCode === 32)
    ) {
      event.preventDefault();
    }
  }

  addRow(data: any) {
    const row = this._formBuilder.group({
      id: [data.id || null],
      position: [data.position || ''],
      serviceCode: [data.serviceCode || ''],
      serviceDescription: [data.serviceDescription || ''],
      scopeOfWork: [data.scopeOfWork || ''],
      buyerComment: [data.buyerComment || ''],
      supplierComment: [data.supplierComment || ''],
      attachments: [data.attachments || []],
      uom: [data.uom || ''],
      supplierUom: [data.supplierUom || ''],
      quantity: [data.quantity || 0],
      supplierQuantity: [data.supplierQuantity || 0],
      unitCost: [this.round3(data.price || 0.00), Validators.pattern(/^\d+(\.\d+)?$/)],
      requestedUnitCost: [this.round3(data.price || 0.00)],
      discount: [Number(data.discount || 0.00), Validators.pattern(/^\d+(\.\d+)?$/)],
      discountedUnitPrice: [this.round3(data.discountedUnitPrice || 0.00), Validators.pattern(/^\d+(\.\d+)?$/)],
      totalCost: [this.round3(data.totalCost || 0.00), Validators.pattern(/^\d+(\.\d+)?$/)],
      requestedTotalCost: [this.round3(data.totalCost || 0.00)],
      isActive: [data.isActive],
      declineReasonTypeId: [data.declineReasonTypeId || null],
      delineOtherReason: [data.delineOtherReason || ''],
      declineReasonDescription: [data.declineReasonDescription || ''],
      leadTime: [data.leadTime || 0],
      isNew: [data.isNew || 0],
    });

    this.rows.push(row);

    setTimeout(() => {
      this.cdr.detectChanges();
    }, 0);
  }

  addNewLineItem() {
    const obj = {
      position: this.dataSource.length + 1,
      id: null,
      serviceCode: '',
      serviceDescription: '',
      scopeOfWork: '',
      buyerComment: null,
      supplierComment: '',
      attachments: [],
      uom: null,
      quantity: 0,
      supplierUom: null,
      supplierQuantity: 0,
      unitCost: 0,
      discount: 0,
      totalCost: 0,
      isActive: 1,
      isNew: 1,
    };

    this.addRow(obj);
    this.dataSource = [...this.dataSource, obj];
  }

  get rows(): FormArray {
    return this.lineItemtableForm.get('rows') as FormArray;
  }

  async prefillRfqLineItems() {
    if (this.serviceRfqId) {
      this.fullLoaderService.showLoader();

      let params = {
        serviceRfqId: this.serviceRfqId,
        supplierId: Number(this.serviceRfqTokenAuth.getSupplierId()),
      };

      const data = await this.quoteService.fetchServiceRfqLineItemsForQuoteByServiceRfqToken(params);

      if (data && data.length > 0) {
        this.dataSource = [];

        data.forEach((item: any, index: any) => {
          const obj = {
            position: index + 1,
            id: null,
            serviceCode: item.serviceName,
            serviceDescription: item.serviceDescription,
            scopeOfWork: item.scopeOfWork || '',
            buyerComment: item.buyerComment,
            supplierComment: '',
            attachments: '',
            uom: item.unit,
            quantity: item.quantity,
            supplierUom: item.unit,
            supplierQuantity: item.quantity,
            unitCost: 0,
            discount: 0,
            totalCost: 0,
            isActive: item.isActive ?? 1,
          };

          this.dataSource.push(obj);
        });
      }

      this.populateForm(this.dataSource);
      this.fullLoaderService.hideLoader();
    }
  }

  async fetchServiceRfqDetails() {
    let paramsData = {
      serviceRfqId: this.serviceRfqId,
      supplierId: Number(this.serviceRfqTokenAuth.getSupplierId()),
    };
    const data = await this.quoteService.fetchServiceRfqDetailsByServiceRfqToken(paramsData);
    if (data && data.rfqData && data.rfqData.length > 0) {
      this.headerData = data.rfqData[0];

      // Nest vessel data into a vessel object to match HTML template bindings
      this.headerData.vessel = {
        vesselName: this.headerData.vesselName,
        imoNumber: this.headerData.vesselImoNumber,
        typeOfVessel: this.headerData.vesselType,
        class: this.headerData.vesselClass,
      };

      // Nest currency data to match HTML template bindings (headerData?.currencyId?.currencyCode)
      this.headerData.currencyId = {
        id: this.headerData.currencyId || null,
        currencyCode: this.headerData.currencyCode,
        currencyName: this.headerData.currencyName,
      };

      // Parse buyerAttachments if it's a JSON string
      if (this.headerData.buyerAttachments && typeof this.headerData.buyerAttachments === 'string') {
        try {
          this.headerData.buyerAttachments = JSON.parse(this.headerData.buyerAttachments);
        } catch (e) {
          this.headerData.buyerAttachments = [];
        }
      }
    }
    console.log('Service RFQ Header Data ', this.headerData);

    // Set supplierCurrency to buyer's requested currency — supplier must quote in this currency
    if (this.headerData?.currencyId) {
      this.secondFormGroup.patchValue({
        supplierCurrency: this.headerData.currencyId,
      });
    }

    this.fullLoaderService.hideLoader();
  }

  async selectMatTabLink(tabItem: any) {
    await this.save();
    if (this.showNotification) return;

    if (tabItem.route == 'header') {
      if (this.isSaved) {
        this.activatedRoute.queryParams.subscribe(async (params) => {
          if (params['serviceRfqId'] != '' && params['quoteId'] != '') {
            this.serviceRfqId = params['serviceRfqId'];
            this.quoteId = params['quoteId'];

            this.router.navigate(['/serviceRfqToken/quote-header-details'], {
              queryParams: { serviceRfqId: this.serviceRfqId, quoteId: this.quoteId }
            });
          }
        });
      }
    } else if (tabItem.route == 'payment-terms') {
      if (this.isSaved) {
        this.activatedRoute.queryParams.subscribe(async (params) => {
          if (params['serviceRfqId'] != '' && params['quoteId'] != '') {
            this.serviceRfqId = params['serviceRfqId'];
            this.quoteId = params['quoteId'];

            this.router.navigate(
              ['/serviceRfqToken/quote-payment-terms'],
              {
                queryParams: { serviceRfqId: this.serviceRfqId, quoteId: this.quoteId },
              }
            );
          }
        });
      } else {
        this.snack.open(`please save the 'Line item' tab first`, 'OK', {
          duration: 3000,
        });
      }
    } else if (tabItem.route == 'preview') {
      if (this.isSaved) {
        this.activatedRoute.queryParams.subscribe(async (params) => {
          if (params['serviceRfqId'] != '' && params['quoteId'] != '') {
            this.serviceRfqId = params['serviceRfqId'];
            this.quoteId = params['quoteId'];

            this.router.navigate(['/serviceRfqToken/quote-preview'], {
              queryParams: { serviceRfqId: this.serviceRfqId, quoteId: this.quoteId },
            });
          }
        });
      } else {
        this.snack.open(`please save the 'Line item' tab first`, 'OK', {
          duration: 3000,
        });
      }
    }
  }

  async close(isDraft: boolean) {
    if (!isDraft) {
      this.showConfirmationDialogue = true;
    } else {
      this.showCloseDialogue = true;
    }
  }

  cancel() {
    this.showConfirmationDialogue = false;
    this.showCloseDialogue = false;
  }

  toggleShowHeaderDetails(event: { checked: boolean }) {
    this.showDetailSection = event.checked;
  }

  toggleWrapDescription(event: MatSlideToggleChange) {
    this.isWrapDescription = event.checked;
  }

  toggleSidebar(value: boolean, section: string, index?: number) {
    if (section == 'attachment') {
      this.showAddDocumentSection = value;
      if (index !== undefined) {
        this.selectedLineItemIndex = index;
      }
    } else if (section == 'cost') {
      this.showAddCostSection = value;
    } else if (section == 'decline') {
      if (!value) {
        // Closing the decline sidebar
        this.showDeclineSection = false;
        this.declineReason = null;
        this.otherReason = '';
        this.showOtherReason = false;
      } else if (index !== undefined) {
        const rows = this.lineItemtableForm.get('rows') as FormArray;
        const selectedRow = rows.at(index);

        if (selectedRow.value.isNew === 1) {
          rows.removeAt(index);
          this.dataSource.splice(index, 1);
          this.dataSource = [...this.dataSource];
          this.snack.open(`New line item removed.`, 'OK', { duration: 3000 });
          this.calculateCostSummary();
        } else {
          this.selectedLineItemIndex = index;
          this.showDeclineSection = value;
        }
      }
    } else if (section == 'freight') {
      this.isFreight = true;
    }
  }

  fileOver(event: any) {}
  fileLeave(event: any) {}

  async onAttachmentChange(files: NgxFileDropEntry[]) {
    try {
      const rows = this.lineItemtableForm.get('rows') as FormArray;

      if (this.selectedAttachmentType == undefined || this.selectedAttachmentType == null) {
        this.snack.open('Please select the attachment type.', 'OK', { duration: 3000 });
        return;
      }

      if (
        this.selectedAttachmentType == 1 ||
        this.selectedAttachmentType == 4
      ) {
        if (
          this.hazardousDeclaration == null ||
          this.hazardousDeclaration == undefined
        ) {
          this.snack.open('Hazardous Declaration can not be empty.', 'OK', {
            duration: 3000,
          });
          return;
        }
      }

      this.newfileuploaded = true;
      this.fullLoaderService.showLoader();

      if (this.selectedLineItemIndex != null) {
        this.uploadedAttachmentsArray =
          rows.at(this.selectedLineItemIndex).get('attachments')?.value || [];

        if (this.uploadedAttachmentsArray.length > 5) {
          throw new Error('Maximum 5 files allowed!');
        }

        const fileEntries = files
          .filter((entry) => entry.fileEntry.isFile)
          .map((ele) => ele.fileEntry as FileSystemFileEntry);

        if (fileEntries.length === 0) {
          throw new Error('Please upload valid files!');
        }
        if (fileEntries.length > 5) {
          throw new Error('Maximum 5 files allowed!');
        }

        await new Promise((res, rej) => {
          fileEntries.map((fileEntry) => {
            fileEntry.file(async (file) => {
              let fileExt = file.name.split('.').pop()?.toLowerCase();
              if (!this.acceptedAttachmentExtenstion.includes(`.${fileExt}`)) {
                throw new Error('Invalid file type! Allowed: PDF, JPG, JPEG, PNG');
              }

              if (file.size > this.maxFileSize) {
                throw new Error('File size must be less than 10MB!');
              }

              let uploadedAttachment: any = {
                lineItemIndex: this.selectedLineItemIndex,
                dataUrl: '',
                name: file.name,
                file: file,
                attachmentType: this.selectedAttachmentType,
                hazardousDeclaration: this.hazardousDeclaration,
              };

              await new Promise((res) => {
                const reader = new FileReader();
                reader.onload = (e: any) => {
                  uploadedAttachment.dataUrl = e.target.result;
                  res(true);
                };
                reader.readAsDataURL(file);
              });

              this.uploadedAttachmentsArray.push(uploadedAttachment);
              res(file);
            });
          });
        });

        rows.at(this.selectedLineItemIndex).patchValue({
          attachments: this.uploadedAttachmentsArray,
        });

        this.fullLoaderService.hideLoader();
      }
    } catch (error: any) {
      this.snack.open(error?.message || error, 'OK', { duration: 3000 });
    }
  }

  onDeclineReasonChange(event: MatSelectChange) {
    const selectedValue = event.value;
    const othersReason = this.delineReasonData.find((item) => item.reasonDescription === 'Others');
    this.showOtherReason = othersReason ? selectedValue == othersReason.id : false;
  }

  onAttachmentTypeChange(event: MatSelectChange) {
    const selectedValue = event.value;

    if (selectedValue == 1 || selectedValue == 4) {
      this.showHazardousDeclaration = true;
    } else {
      this.showHazardousDeclaration = false;
    }
  }

  declineLineItem() {
    const rows = this.lineItemtableForm.get('rows') as FormArray;

    if (this.declineReason == undefined || this.declineReason == null) {
      this.snack.open('Please select the decline reason.', 'OK', { duration: 3000 });
      return;
    }

    const othersReason = this.delineReasonData.find((item) => item.reasonDescription === 'Others');
    if (othersReason && this.declineReason == othersReason.id && (this.otherReason == null || this.otherReason == '')) {
      this.snack.open('Other reason can not be empty.', 'OK', { duration: 3000 });
      return;
    }

    const reason = this.delineReasonData.find((item) => item.id === this.declineReason);
    const reasonDesc = reason ? reason.reasonDescription : 'Reason not found';

    if (this.selectedLineItemIndex != null) {
      rows.at(this.selectedLineItemIndex).patchValue({
        isActive: 0,
        declineReasonTypeId: this.declineReason,
        delineOtherReason: this.otherReason,
        declineReasonDescription: reasonDesc,
        attachments: [],
        supplierQuantity: 0,
      });

      this.snack.open(`Line Item Declined, selected line item attachments are removed`, 'OK', { duration: 3000 });
    }

    this.showDeclineSection = false;
    this.declineReason = null;
    this.otherReason = '';
    this.selectedLineItemIndex = null;
    this.calculateCostSummary();
  }

  restoreLineitem(index: number) {
    const rows = this.lineItemtableForm.get('rows') as FormArray;
    const quantityValue = rows.at(index).get('quantity')?.value;

    rows.at(index).patchValue({
      isActive: 1,
      declineReasonTypeId: null,
      delineOtherReason: null,
      declineReasonDescription: null,
      supplierQuantity: quantityValue || 1,
    });

    this.snack.open(`Line Item Restored`, 'OK', { duration: 3000 });
    this.calculateCostSummary();
  }

  isDecline(index: number) {
    const rows = this.lineItemtableForm.get('rows') as FormArray;
    const row = rows.at(index);
    return row.get('isActive')?.value === 0;
  }

  getDeclineReason(index: number) {
    const rows = this.lineItemtableForm.get('rows') as FormArray;
    const row = rows.at(index);
    const reason = row.get('declineReasonDescription')?.value || '';
    return `Declined - ${reason || 'No reason provided'}`;
  }

  isNew(index: number) {
    const rows = this.lineItemtableForm.get('rows') as FormArray;
    const row = rows.at(index);
    return row.get('isNew')?.value === 1;
  }

  addCost() {
    this.freightDescription = 'Freight';
    this.isFreightCost = true;
    this.showAddCostSection = true;
  }

  addMoreCostAtFreight() {
    let params = {
      id: null,
      freightDescription: this.freightDescription,
      freightType: this.freightType,
      freightValue: this.freightValue || 0,
      isActive: 1,
    };
    this.addedAdditionalCost.push(params);

    this.secondFormGroup.get('quoteLineItemFreight')?.setValue(this.addedAdditionalCost);
    this.calculateCostSummary();

    this.showAddCostSection = true;
    this.freightDescription = '';
    this.freightType = 'amount';
    this.freightValue = null;
    this.isFreightCost = false;
  }

  addMoreCost() {
    this.showAddCostSection = true;
  }

  cancelAddCost() {
    this.showAddCostSection = false;
    this.freightDescription = '';
    this.freightType = 'amount';
    this.freightValue = null;
    this.isFreightCost = false;
  }

  removeAdditionalCost(index: number) {
    if (index > -1 && index < this.addedAdditionalCost.length) {
      this.addedAdditionalCost.splice(index, 1);
      this.secondFormGroup.get('quoteLineItemFreight')?.setValue(this.addedAdditionalCost);
      this.calculateCostSummary();
      this.snack.open('Cost removed successfully.', 'OK', { duration: 3000 });
    }
  }

  onFreightEditComplete(index: number, item: any, event: any) {
    if (item.freightDescription?.trim()?.toLowerCase() !== 'freight') return;

    const oldValue = Number(item.freightValue);
    const cleaned = String(event.target.value || '').replace(/,/g, '');
    const newValue = this.round3(Number(cleaned));

    if (isNaN(newValue) || newValue === oldValue) return;
    if (!oldValue || oldValue === 0) return;

    const existingFreight = this.addedAdditionalCost.find(
      (cost: any) => cost.freightDescription?.trim()?.toLowerCase() === 'freight'
    );

    if (existingFreight) {
      existingFreight.freightValue = newValue;
      this.secondFormGroup.get('quoteLineItemFreight')?.setValue(
        this.addedAdditionalCost.map((f: any) => ({ ...f, freightValue: this.round3(f.freightValue) }))
      );
      this.calculateCostSummary();
    }
    this.isFreight = false;
  }

  saveAdditionalCost() {
    if (this.freightDescription == '' || this.freightType == '' || this.freightValue == null) {
      this.snack.open('Please fill the additional cost details.', 'OK', { duration: 3000 });
      return;
    }
    let params = {
      id: null,
      freightDescription: this.freightDescription,
      freightType: this.freightType,
      freightValue: this.round3(this.freightValue),
      isActive: 1,
    };
    this.addedAdditionalCost.push(params);

    this.secondFormGroup.get('quoteLineItemFreight')?.setValue(
      this.addedAdditionalCost.map((f: any) => ({ ...f, freightValue: this.round3(f.freightValue) }))
    );
    this.calculateCostSummary();

    this.showAddCostSection = false;
    this.freightDescription = '';
    this.freightType = 'amount';
    this.freightValue = null;
  }

  async getQuoteDraftData() {
    this.fullLoaderService.showLoader();

    const data = await this.quoteService.getServiceQuoteDraftDataByServiceRfqToken('tab2', Number(this.quoteId));

    if (
      data &&
      data.length > 0 &&
      Object.keys(data[0]).length > 0 &&
      data[0].quotationLineItems &&
      data[0].quotationLineItems.length > 0
    ) {
      if (data[0].quotationLineItems[0].quoteLineItemDetailsId) {
        this.isSaved = true;
      }

      this.secondFormGroup.patchValue({
        quoteLineItemHeaderId: data[0].quoteLineItemHeaderId || '',
        quoteLineItemListPriceSubtotal: this.round3(data[0].quoteLineItemListPriceSubtotal || 0),
        quoteLineItemDiscount: this.round3(data[0].quoteLineItemDiscount || 0),
        quoteLineItemSubtotal: this.round3(data[0].quoteLineItemSubtotal || 0),
        quoteLineItemGeneralDiscountType: data[0].quoteLineItemGeneralDiscountType || 'percentage',
        quoteLineItemGeneralDiscountValue: this.round3(data[0].quoteLineItemGeneralDiscountValue || 0),
        quoteLineItemFreightTotal: this.round3(data[0].quoteLineItemFreightTotal || 0),
        quoteLineItemFreight: (data[0].quoteLineItemFreight || []).map((f: any) => ({
          ...f,
          freightValue: this.round3(f?.freightValue || 0),
        })),
        quoteLineItemTotal: this.round3(data[0].quoteLineItemTotal || 0),
        supplierCurrency: data[0].supplierCurrency,
        quoteLineItemApplicableTaxProfile: data[0].quoteLineItemApplicableTaxProfile || null,
        quoteLineItemTaxAmount: this.round3(data[0].quoteLineItemTaxAmount || 0),
      });

      let resolvedTaxType!: string | null;
      const selectedTaxProfileId = data[0].quoteLineItemApplicableTaxProfile;
      if (!resolvedTaxType && selectedTaxProfileId && Array.isArray(this.taxStatusData) && this.taxStatusData.length > 0) {
        const selectedTaxProfile = this.taxStatusData.find(
          (t: any) => t.taxId === Number(selectedTaxProfileId)
        );
        if (selectedTaxProfile) {
          resolvedTaxType = selectedTaxProfile.taxType || null;
        }
        this.secondFormGroup.patchValue({ quoteLineItemTaxType: resolvedTaxType });
        this.quoteLineItemTaxType = resolvedTaxType;
      }

      this.dataSource = [];

      if (data[0].quotationLineItems && data[0].quotationLineItems.length > 0) {
        data[0].quotationLineItems.forEach(
          (item: any, index: number) => {
            const obj = {
              position: index + 1,
              id: item.quoteLineItemDetailsId,
              serviceCode: item.serviceName,
              serviceDescription: item.serviceDescription,
              scopeOfWork: item.scopeOfWork || '',
              buyerComment: item.buyerComment,
              supplierComment: item.supplierComment,
              uom: item.uom,
              supplierUom: item.supplierUom,
              quantity: item.quantity,
              supplierQuantity: item.supplierQuantity,
              price: this.round3(item.unitCost),
              discount: Number(item.discount),
              discountedUnitPrice: this.round3(item.discountedUnitPrice),
              totalCost: this.round3(item.totalCost),
              isActive: item.isActive,
              declineReasonTypeId: item.declineReasonTypeId,
              delineOtherReason: item.delineOtherReason,
              declineReasonDescription: item.declineReasonDescription,
              attachments: item.attachments,
              leadTime: item.leadTime,
              isNew: 0,
            };

            this.dataSource.push(obj);
          }
        );

        this.populateForm(this.dataSource);
      }

      // Populate addedAdditionalCost from freight data
      if (data[0].quoteLineItemFreight && data[0].quoteLineItemFreight.length > 0) {
        this.addedAdditionalCost = data[0].quoteLineItemFreight.map((f: any) => ({
          id: f.id || null,
          freightDescription: f.freightDescription,
          freightType: f.freightType,
          freightValue: this.round3(f.freightValue || 0),
          isActive: f.isActive || 1,
        }));
      }

      this.onGeneralDiscountBlur();
      this.fullLoaderService.hideLoader();
    } else {
      this.prefillRfqLineItems();
      // Currency is now set from buyer's requested currency in fetchServiceRfqDetails()
      // this.fetchDefaultCurrency();
    }

    this.fullLoaderService.hideLoader();
  }

  dismissNotification() {
    this.showNotification = false;
  }

  showMissingFieldsNotification(missingFields: { section: string; fields: string[] }[]) {
    let message = '<strong>Please fill all the missing fields before proceeding:</strong><br><br>';

    missingFields.forEach((missingField) => {
      message += `<strong>${missingField.section}:</strong><br>`;
      message += missingField.fields.map((field) => `  - ${field}`).join('<br>');
      message += '<br><br>';
    });

    this.notificationMessage = message;
    this.notificationTitle = 'Missing Fields';
    this.notificationType = 'error';
    this.showNotification = true;
  }

  isValidRequiredFields(): { section: string; fields: string[] }[] {
    const missingFields: { section: string; fields: string[] }[] = [];
    const lineItemMissingFields: string[] = [];
    const lineItems = this.lineItemtableForm.value?.rows || [];

    lineItems.forEach((item: any, index: number) => {
      if (item.isActive === 0) return;
      if (!item.unitCost || item.unitCost <= 0) {
        lineItemMissingFields.push(`Unit Cost for line item #${index + 1}`);
      }
      if (!item.leadTime || item.leadTime <= 0) {
        lineItemMissingFields.push(`Lead Time for line item #${index + 1}`);
      }
    });

    const form = this.secondFormGroup;
    if (!form.get('supplierCurrency')?.value) {
      lineItemMissingFields.push('Preferred Currency');
    }

    if (lineItemMissingFields.length > 0) {
      missingFields.push({ section: 'Line Items', fields: lineItemMissingFields });
    }

    if (missingFields.length > 0) {
      this.showMissingFieldsNotification(missingFields);
    }

    return missingFields;
  }

  getLineItemAttachment() {
    const rows = this.lineItemtableForm.value.rows;
    if (this.selectedLineItemIndex != null) {
      const row = rows[this.selectedLineItemIndex];
      return row.attachments || [];
    }
    return [];
  }

  filterFieldCurrencyNameDisplayFn(_currency: Currency) {
    return _currency ? `${_currency.currencyCode}` : undefined;
  }

  getCurrencyFilterKeyDataObservable(pageMeta: Page) {
    pageMeta.serachParam =
      pageMeta.serachParam || pageMeta.serachParam == ''
        ? pageMeta.serachParam
        : this.searchKeyParams;
    this.searchKeyParams = pageMeta.serachParam;
    return from(this.quoteService.getAllCurrenciesByFliterKeyValueByServiceRfqToken(
      pageMeta.serachParam,
      pageMeta.pageNumber || 1,
      pageMeta.size || 10
    ));
  }

  getCurrencyControl(): any {
    return this.secondFormGroup.get('supplierCurrency') as FormControl;
  }

  async getTaxDetails() {
    this.fullLoaderService.showLoader();
    let data = {
      supplierId: Number(this.serviceRfqTokenAuth.getSupplierId()),
    };
    const response = await this.quoteService.getTaxDetailsBySupplierByServiceRfqToken();
    this.taxStatusData = response.rows;
    this.fullLoaderService.hideLoader();
  }

  async fetchDefaultCurrency() {
    const transactionSetupdata = await this.quoteService.fetchSupplierSetupByServiceRfqToken(
      'TransactionSetup'
    );

    if (transactionSetupdata.length > 0) {
      this.secondFormGroup.patchValue({
        supplierCurrency: {
          id: transactionSetupdata[0].default_currency,
          currencyName: transactionSetupdata[0].currencyName,
          currencyCode: transactionSetupdata[0].currencyCode,
          currencySymbol: transactionSetupdata[0].currencySymbol,
        },
      });
    }
  }

  async togglePreview(value: boolean, section: string, docs?: any) {
    this.previewSection = value;
    this.previewDocs = [];
    if (docs) {
      if (section == 'single') {
        this.previewDocs.push(docs);
      } else if (section == 'multiple') {
        this.previewDocs = docs;
      }
    }
  }

  nextSlide() {
    this.currentIndex = (this.currentIndex + 1) % this.previewDocs.length;
  }

  prevSlide() {
    this.currentIndex =
      (this.currentIndex - 1 + this.previewDocs.length) % this.previewDocs.length;
  }

  isPdf(urlOrDataUrl: string): boolean {
    if (urlOrDataUrl?.toLowerCase().startsWith('data:application/pdf')) return true;
    return urlOrDataUrl?.toLowerCase().endsWith('.pdf');
  }

  onTaxProfileChange(event: MatSelectChange) {
    const selectedTaxId = event.value;
    const selectedTaxProfile = this.taxStatusData.find(
      (item) => item.taxId === Number(selectedTaxId)
    );

    if (selectedTaxProfile) {
      const taxType = selectedTaxProfile.taxType;
      this.secondFormGroup.patchValue({ quoteLineItemTaxType: taxType });
      this.quoteLineItemTaxType = taxType;
      this.isTotalsCardOpen = false;
    }

    this.calculateCostSummary();
  }

  async rfqActions(action: string) {
    if (action == 'download') {
      this.fullLoaderService.showLoader();

      let fileName = this.headerData?.rfqRefNumber + '.pdf';

      const pdf = await this.quoteService.generateSupplierServiceRfqAttachmentByServiceRfqToken(
        this.serviceRfqId,
        Number(this.serviceRfqTokenAuth.getSupplierId())
      );

      const uint8Array = new Uint8Array(pdf.data);
      const blob = new Blob([uint8Array], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      this.fullLoaderService.hideLoader();
    } else if (action == 'decline') {
      // decline action
    } else if (action == 'acknowledge') {
      this.fullLoaderService.showLoader();

      let data = {
        operation: action,
        selectedRfqId: [this.headerData.supplierRfqId],
      };

      await this.quoteService.acknowledgeServiceRfqByServiceRfqToken(data);
      this.fullLoaderService.hideLoader();
      this.snack.open('RFQ has been acknowledged', 'OK', {
        duration: 3000,
      });
    }
    this.fetchServiceRfqDetails();
  }

  showInfo(): void {
    console.log('Info icon clicked - show additional info!');
  }

  applyConversionToUnitCost(
    row: any,
    supplierCurrency: string,
    baseCurrency: string,
    supplierAmount: number
  ) {
    const rates = this.exchangeRatesCache[baseCurrency];

    if (rates && rates[supplierCurrency]) {
      const conversionRate = rates[supplierCurrency];
      const convertedAmount = this.round3(supplierAmount * conversionRate);

      row.get('requestedUnitCost')?.setValue(convertedAmount);
      console.log(
        `Converted amount for ${supplierCurrency} to ${baseCurrency}: ${convertedAmount}`
      );
    } else {
      this.snack.open('Conversion rate not available', 'Close', {
        duration: 4000,
      });
      row.get('requestedUnitCost')?.setValue(0);
    }
  }

  applyConversionToTotalCost(
    row: any,
    supplierCurrency: string,
    baseCurrency: string,
    supplierAmount: number
  ) {
    const rates = this.exchangeRatesCache[baseCurrency];

    if (rates && rates[supplierCurrency]) {
      const conversionRate = rates[supplierCurrency];
      const convertedAmount = this.round3(supplierAmount * conversionRate);

      row.get('requestedTotalCost')?.setValue(convertedAmount);
      console.log(
        `Converted amount for ${supplierCurrency} to ${baseCurrency}: ${convertedAmount}`
      );
    } else {
      this.snack.open('Conversion rate not available', 'Close', {
        duration: 4000,
      });
      row.get('requestedTotalCost')?.setValue(0);
    }
  }

  // ─── Tax Profile Sidebar Methods ───

  loadCountryList() {
    this.SettingsService.getAllCountriesByFliterKeyValue().subscribe({
      next: (res: any) => {
        this.countryList = Array.isArray(res?.rows) ? res.rows : [];
        this.filteredCountryList = [...this.countryList];
      },
      error: () => {
        this.countryList = [];
        this.filteredCountryList = [];
      },
    });
  }

  filterCountries(searchText: string): void {
    if (!searchText) {
      this.filteredCountryList = [...this.countryList];
    } else {
      const regex = new RegExp(searchText, 'i');
      this.filteredCountryList = this.countryList.filter((c: any) => regex.test(c.name));
    }
  }

  countryDisplayFn(country: any): string {
    return country ? country.name : '';
  }

  toggleTaxSidebar(): void {
    if (this.showTaxSideBar) {
      this.taxForm.reset();
      this.countryRegions = [];
      this.filteredCountryList = [...this.countryList];
    }
    this.showTaxSideBar = !this.showTaxSideBar;
  }

  onTaxCountrySelected(country: any): void {
    this.taxForm.get('region')?.reset();
    this.taxForm.get('regionName')?.reset();
    this._selectedCountryCode = country?.code || '';
    this.quoteService
      .getAllRegionsByFliterKeyValueByServiceRfqToken(this._selectedCountryCode)
      .then((data: any) => {
        if (Array.isArray(data)) {
          this.countryRegions = data;
        } else if (Array.isArray(data?.rows)) {
          this.countryRegions = data.rows;
        } else {
          this.countryRegions = [];
        }
      })
      .catch(() => {
        this.countryRegions = [];
      });
  }

  onTaxRegionSelected(selectedIso: string): void {
    const selectedRegion = this.countryRegions.find((region: any) => region.iso === selectedIso);
    if (selectedRegion) {
      this.taxForm.patchValue({ regionName: selectedRegion.name });
    }
  }

  allowOnlyDecimalTax(event: KeyboardEvent): void {
    const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'];
    const input = event.target as HTMLInputElement;

    if (!allowedKeys.includes(event.key)) {
      event.preventDefault();
      return;
    }

    if (event.key === '.' && input.value.includes('.')) {
      event.preventDefault();
    }
  }

  async onGstAttachmentChange(files: NgxFileDropEntry[]) {
    try {
      if (files.length > 1) {
        this.snack.open('Please drop only one file at a time.', 'OK', { duration: 1000 });
        return;
      }
      const fileEntry = files[0].fileEntry as FileSystemFileEntry;
      await new Promise((res, rej) => {
        fileEntry.file(file => {
          this.gstCertificateFile = file;
          res(file);
        });
      });
    } catch (error: any) {
      this.snack.open(error, 'OK', { duration: 1000 });
    }
  }

  async uploadTaxCertificate(file: File, formData: any) {
    this.fullLoaderService.showLoader('Uploading Certificate...');
    if (file != null) {
      let fileExt = file.name.slice(
        ((file.name.lastIndexOf('.') - 1) >>> 0) + 2
      );

      let fileName = uuidv4() + '.' + fileExt.toLowerCase();
      let s3Location = `gstCertificate/${fileName}`;

      let _s3Params = {
        fileKey: s3Location,
        fileContentType: (<File>file).type,
      };

      await this.awsSdkService
        .getSignedUrlPromise(_s3Params)
        .then((_fileUploadLink) => {
          if (_fileUploadLink) {
            this.webApiService
              .putRequestExternalApi(_fileUploadLink, file)
              .then(async (_fileUploadData: any) => {
                let filePath =
                  this.awsSdkService.extractS3LocationFromUrl(_fileUploadLink);

                await this.addNewTaxProfile(formData, filePath);

                this.taxForm.patchValue({
                  gstCertificateAttachment: filePath,
                });
              })
              .catch((_httpErrorResponse: HttpErrorResponse) => {
                console.log('Error while uploading file==>', _httpErrorResponse);
                this.fullLoaderService.hideLoader();
                this.snack.open('Error uploading certificate', 'OK', { duration: 3000 });
              });
          }
        })
        .catch((error) => {
          console.log('Error getting presigned URL==>', error);
          this.fullLoaderService.hideLoader();
        });
    }
  }

  async addNewTaxProfile(formdata: any, filePath: string) {
    try {
      const data = {
        taxId: formdata.taxId,
        nameofTaxProfile: formdata.nameOfTaxProfile,
        taxType: formdata.taxType,
        taxNumber: formdata.taxNumber,
        taxPercentage: formdata.taxPercentage,
        country: formdata.country?.name,
        region: { name: formdata.regionName, iso: formdata.region },
        supplierId: Number(this.serviceRfqTokenAuth.getSupplierId()),
        s3FilePath: filePath,
      };

      const response = await this.quoteService.addTaxDetailsBySupplierByServiceRfqToken(data);
      this.gstCertificateFile = undefined as any;

      const message = response?.message ||
        (response?.success ? 'Tax Details Added!!' : 'Error in Adding Tax Details!!');
      this.snack.open(message, 'OK', { duration: 3000 });

      await this.getTaxDetails();
    } catch (_httpErrorResponse: any) {
      console.log(_httpErrorResponse);
      this.fullLoaderService.hideLoader();
      if (_httpErrorResponse instanceof HttpErrorResponse) {
        this.snack.open(`${_httpErrorResponse.error.errors[0].message}`, 'OK', { duration: 3000 });
      } else {
        this.snack.open(`${_httpErrorResponse}`, 'OK', { duration: 3000 });
      }
    }
  }

  async saveTaxForm() {
    if (this.taxForm.valid) {
      const formData = { ...this.taxForm.value };
      const certFile = this.gstCertificateFile;
      this.toggleTaxSidebar();
      if (certFile) {
        await this.uploadTaxCertificate(certFile, formData);
      } else {
        this.fullLoaderService.showLoader('Saving Tax Profile...');
        await this.addNewTaxProfile(formData, formData.s3FilePath || '');
      }
    }
  }
}
